/* global axios */
import ApiClient from './ApiClient';

class CrmCallsAPI extends ApiClient {
  constructor() {
    super('crm_calls', { accountScoped: true });
  }
}

class CrmMeetingsAPI extends ApiClient {
  constructor() {
    super('crm_meetings', { accountScoped: true });
  }
}

class CrmTasksAPI extends ApiClient {
  constructor() {
    super('crm_tasks', { accountScoped: true });
  }
}

export const callsAPI = new CrmCallsAPI();
export const meetingsAPI = new CrmMeetingsAPI();
export const tasksAPI = new CrmTasksAPI();
